import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ShimmerLoader from "../../../pages/ShimmerLoader/ShimmerLoader";
import { fetchDailyPointReport } from "../../../../store/actions/report/ReportsAction";
import NoDataFound from "../../common/NoDataFound";
import Styles from "./DailyPointReport.module.css";
import moment from "moment-timezone";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";

const DailyPointReport = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = Number(process.env.REACT_APP_ITEMS_PER_PAGE);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchDailyPointReport({}, navigate));
  }, [dispatch, navigate]);

  const { dailyCustomerPoint, loading, error } = useSelector((state) => state.reports);

  const totalPages = dailyCustomerPoint && Math.ceil(dailyCustomerPoint.length / itemsPerPage);

  // Toast default options
  const defaultOptions = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    theme: "colored",
  };

  const onPageChange = (increment) => {
    setCurrentPage((prevPage) => Math.max(1, Math.min(prevPage + increment, totalPages)));
  };

  const handleRowClick = (customer_id) => {
    navigate(`/view-customer-details/${customer_id}`);
  };

  const handleDownload = () => {
    if (dailyCustomerPoint.length === 0) {
      toast.info("No data available for download!", defaultOptions);
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(
      dailyCustomerPoint.map((item) => ({
        Name: item.name || "--",
        Phone: item.mobile_no ? item.mobile_no : "--",
        "Pan No": item.pan_no ? item.pan_no : "--",
        "Transaction Date": item.trans_date ? convertToIST(item.trans_date) : "--",
        "Total Reward Points": item.total_reward_points ? item.total_reward_points : "--",
        Address: item.address ? item.address : "--",
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Daily Point");
    XLSX.writeFile(workbook, `Daily Point Reports_${moment().format("YYYY-MM-DD")}.xlsx`);
  };

  // Get current items for the current page
  const currentItems = dailyCustomerPoint.length > 0 && dailyCustomerPoint.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const convertToIST = (isoDateTime) => {
    return moment(isoDateTime).format("Do MMM YYYY");
  };

  // return (
  //   <>
  //     <div className='row page-titles'>
  //       <ol className='breadcrumb'>
  //         <li className='breadcrumb-item active'>
  //           <Link to={"#"}>Reports</Link>
  //         </li>
  //       </ol>
  //     </div>
  //     {loading && <ShimmerLoader width='95%' height='20%' count={4} />}
  //     {!loading && (
  //       <div className='row'>
  //         <div className='col-lg-12'>
  //           <div className='card'>
  //             <div className='card-header'>
  //               <h4 className='card-title'>Daily Point Reports</h4>
  //               <div className='d-flex align-items-center'>
  //                 <button className='btn btn-outline-secondary mx-1' type='button' onClick={handleDownload}>
  //                   Download
  //                 </button>
  //               </div>
  //             </div>
  //             <div className='card-body'>
  //               <div className='table-responsive ticket-table'>
  //                 <div id='ticket_wrapper' className='dataTables_wrapper no-footer'>
  //                   <div className='table-responsive'>
  //                     <table className='display dataTablesCard table-responsive-xl dataTable no-footer w-100'>
  //                       <thead>
  //                         <tr>
  //                           <th>Name</th>
  //                           <th>Phone</th>
  //                           <th>Pan No</th>
  //                           <th>Transaction Date</th>
  //                           <th>Total Reward Points</th>
  //                           <th>Address</th>
  //                         </tr>
  //                       </thead>
  //                       <tbody>
  //                         {currentItems.length > 0 ? (
  //                           currentItems.map((item, index) => (
  //                             <tr key={index}>
  //                               <td>{item.name ? item.name : "--"}</td>
  //                               <td>{item.mobile_no ? item.mobile_no : "--"}</td>
  //                               <td>{item.pan_no ? item.pan_no : "--"}</td>
  //                               <td>{item.trans_date ? convertToIST(item.trans_date) : "--"}</td>
  //                               <td>{item.total_reward_points ? `${item.total_reward_points} gm` : "--"}</td>
  //                               <td>{item.address ? item.address : "--"}</td>
  //                             </tr>
  //                           ))
  //                         ) : (
  //                           <tr className={`${Styles.no_hover}`}>
  //                             <td className={`fs-3 text-center`} colSpan={7}>
  //                               <NoDataFound width={450} />
  //                             </td>
  //                           </tr>
  //                         )}
  //                       </tbody>
  //                     </table>
  //                   </div>
  //                   {dailyCustomerPoint.length > 0 && (
  //                     <div className='d-flex justify-content-end align-items-center px-4 py-2'>
  //                       <div className='dataTables_paginate paging_simple_numbers mb-0 d-flex align-items-center'>
  //                         <i className={`fa fa-chevron-circle-left fa-2x ${currentPage === 1 ? "text-muted" : "text-primary"}`} onClick={() => onPageChange(-1)} style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}></i>
  //                         <span className='mx-2'>
  //                           Page {currentPage} of {totalPages}
  //                         </span>
  //                         <i className={`fa fa-chevron-circle-right fa-2x ${currentPage === totalPages || totalPages === 0 ? "text-muted" : "text-primary"}`} onClick={() => onPageChange(1)} style={{ cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer" }}></i>
  //                       </div>
  //                     </div>
  //                   )}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     )}
  //   </>
  // );
  return (
    <>
      <div className='row page-titles'>
        <ol className='breadcrumb'>
          <li className='breadcrumb-item active'>
            <Link to={"#"}>Reports</Link>
          </li>
        </ol>
      </div>
      <div className='row'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-header'>
              <h4 className='card-title'>Daily Point Reports</h4>
              <div className='d-flex align-items-center'>
                <button className='btn btn-outline-secondary mx-1' type='button' onClick={handleDownload}>
                  Download
                </button>
              </div>
            </div>
            <div className='card-body'>
              <div className='table-responsive ticket-table'>
                <div id='ticket_wrapper' className='dataTables_wrapper no-footer'>
                  <div className='table-responsive'>
                    <table className='display dataTablesCard table-responsive-xl dataTable no-footer w-100'>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Phone</th>
                          <th>Pan No</th>
                          <th>Transaction Date</th>
                          <th>Total Reward Points</th>
                          <th>Address</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={6} className='text-center'>
                              <ShimmerLoader width='95%' height='20%' count={3} />
                            </td>
                          </tr>
                        ) : currentItems.length > 0 ? (
                          currentItems.map((item, index) => (
                            <tr key={index}>
                              <td>{item.name || "--"}</td>
                              <td>{item.mobile_no || "--"}</td>
                              <td>{item.pan_no || "--"}</td>
                              <td>{item.trans_date ? convertToIST(item.trans_date) : "--"}</td>
                              <td>{item.total_reward_points ? `${item.total_reward_points} gm` : "--"}</td>
                              <td>{item.address || "--"}</td>
                            </tr>
                          ))
                        ) : (
                          <tr className={`${Styles.no_hover}`}>
                            <td className={`fs-3 text-center`} colSpan={6}>
                              <NoDataFound width={450} />
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {dailyCustomerPoint.length > 0 && (
                    <div className='d-flex justify-content-end align-items-center px-4 py-2'>
                      <div className='dataTables_paginate paging_simple_numbers mb-0 d-flex align-items-center'>
                        <i className={`fa fa-chevron-circle-left fa-2x ${currentPage === 1 ? "text-muted" : "text-primary"}`} onClick={() => onPageChange(-1)} style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}></i>
                        <span className='mx-2'>
                          Page {currentPage} of {totalPages}
                        </span>
                        <i className={`fa fa-chevron-circle-right fa-2x ${currentPage === totalPages || totalPages === 0 ? "text-muted" : "text-primary"}`} onClick={() => onPageChange(1)} style={{ cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer" }}></i>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DailyPointReport;
